import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const LensRowBadgeWrapper = styled.div`
    display: inline-block;
    vertical-align: middle;
`;

const badgeBase = css`
    margin-inline-start: ${Spacing.XS}px;
    border: none;
`;

export const badgeEnabled = css`
    ${badgeBase};
    background-color: ${Colors.Yellow.V200};
`;

export const badgeWarning = css`
    ${badgeBase};
    color: ${Colors.WHITE};
    background-color: ${Colors.Orange.V200};
`;

export const badgeDisabled = css`
    ${badgeBase};
    background-color: ${Colors.Gray.V100};
`;

export const badgeSpectacles = css`
    ${badgeBase};
    background-color: ${Colors.Yellow.V150};
`;
